module.exports = __webpack_public_path__ + "img/c10.7dcf7d10.jpg";